import chroma from "chroma-js";
function makeChromaScale(def) {
  return chroma.scale(["white", ...Object.values(def).map(String), "black"]).mode("oklch").domain([0, ...Object.keys(def).map(Number), 1e3]);
}
export { makeChromaScale as default };